import { Pipe, PipeTransform } from '@angular/core';
/**
 * Retourne le nom du code d'PrivilegeAssignationSource.
 * la traduction est dans le pipe
 * hardcodé en français pour l'instant
 * @param id
 */
@Pipe({
  name: 'getPrivilegeAssignationSourceName',
})
export class PrivilegeAssignationSourceNamePipe implements PipeTransform {
  names = [
    { privilegeAssignationSourceId: 'DirectlyAssigned', nameFr: 'Direct', nameEn: 'Direct' },
    { privilegeAssignationSourceId: 'AssignedByRole', nameFr: 'Rôle', nameEn: 'Role' },
  ];

  transform(id: any): string {
    // chercher le nom si la liste n'est pas vide
    if (this.names) {
      let name = this.names
        .filter((c: any) => c.privilegeAssignationSourceId == id)
        .map((c: any) => {
          // retourner la description française en MAJUSCULE
          return c.nameFr.toUpperCase();
        });
      if (name && name.length > 0) {
        return name[0];
      }
    }
    // on retourne le id si on ne trouve pas le nom (j'ai vu des id == -1 dans la DB)
    return id <= 0 ? '' : id;
  }
}
